/* Kkumi Email Choice — the page an Oracle email's choice links open (sections/kkumi-email-choice.liquid).

   Opening the link records nothing: email scanners open every link in a message. The page asks the
   rewards worker to DESCRIBE the choice (preview: true), shows what it will do, and records it only when
   the customer presses the button. The link's signed token stays in the address bar until then (a refresh
   asks again, and changes nothing); it's dropped once the choice is saved. Every word comes from the
   section's settings (data-* on the root); only the product's name and how long the choice holds ({duration},
   Oracle's Settings → Engagement → Holds) come from the answer. */
(function () {
  var ACTIONS = { have: 1, no: 1, later: 1 };

  function show(root, state) {
    root.querySelectorAll('[data-choice-state]').forEach(function (el) {
      el.hidden = el.getAttribute('data-choice-state') !== state;
    });
  }

  /* The sentence for this choice, from the settings, with the product's name and how long it holds filled in.
     An answer without a duration (an older Oracle) shows Oracle's own sentence instead, so the page never
     states a length Oracle won't keep. */
  function sentence(root, action, scope, product, duration, oracleWords) {
    var d = root.dataset;
    var tpl = String((action === 'have' ? d.wordsHave : action === 'later' ? d.wordsLater : scope === 'product' ? d.wordsNoProduct : d.wordsNoKind) || '');
    if (tpl.indexOf('{duration}') !== -1 && !duration && oracleWords) return oracleWords;
    return tpl.replace(/\{product\}/g, product || d.productFallback || '').replace(/\{duration\}/g, duration || '');
  }

  function post(root, body) {
    return fetch(root.dataset.endpoint || '/apps/rewards/email-choice', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data }; });
    });
  }

  function dropToken() {
    if (!window.history || !window.history.replaceState) return;
    try { window.history.replaceState(window.history.state, '', window.location.pathname + window.location.hash); } catch (e) {}
  }

  function ask(root, action, words) {
    root.querySelectorAll('[data-choice-heading]').forEach(function (el) { el.hidden = el.getAttribute('data-choice-heading') !== action; });
    root.querySelectorAll('[data-choice-confirm]').forEach(function (el) { el.hidden = el.getAttribute('data-choice-confirm') !== action; });
    var w = root.querySelector('[data-choice-words]');
    if (w) w.textContent = words;
    show(root, 'ask');
  }

  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    // Theme editor: example words, no calls.
    if (root.hasAttribute('data-design-mode')) {
      var pa = root.dataset.previewAction;
      if (ACTIONS[pa]) { var pw = root.querySelector('[data-choice-words]'); if (pw) pw.textContent = sentence(root, pa, 'product', root.dataset.previewProduct, root.dataset.previewDuration); }
      var dw = root.querySelector('[data-choice-words-done]');
      if (dw) dw.textContent = sentence(root, 'have', 'product', root.dataset.previewProduct, root.dataset.previewDuration);
      return;
    }

    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }
    var token = qs.get('t') || '', action = qs.get('a') || '';
    if (!token || !ACTIONS[action]) return; // opened without a link: the "nothing to change" state stands

    show(root, 'checking');
    post(root, { t: token, a: action, preview: true }).then(function (r) {
      if (r.status === 200 && r.data.ok) { ask(root, action, sentence(root, action, r.data.scope, r.data.product, r.data.duration, r.data.words)); return; }
      show(root, r.status === 404 || r.status === 409 || r.status === 400 ? 'invalid' : 'error');
    }).catch(function () { show(root, 'error'); });

    root.querySelectorAll('[data-choice-confirm]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.KKBtn) window.KKBtn.busy(btn, root.dataset.busyLabel || btn.textContent);
        post(root, { t: token, a: action }).then(function (r) {
          if (r.status === 200 && r.data.applied) {
            var done = root.querySelector('[data-choice-words-done]');
            if (done) done.textContent = sentence(root, action, r.data.scope, r.data.product, r.data.duration, r.data.words);
            dropToken();
            show(root, 'done');
            return;
          }
          show(root, r.status === 404 || r.status === 409 || r.status === 400 ? 'invalid' : 'error');
        }).catch(function () {
          show(root, 'error');
        }).finally(function () {
          if (window.KKBtn) window.KKBtn.reset(btn);
        });
      });
    });
  }

  document.querySelectorAll('[data-kkumi-email-choice]').forEach(init);
})();
